import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=66c01522&scoped=true&"
import script from "./reportList.vue?vue&type=script&lang=js&"
export * from "./reportList.vue?vue&type=script&lang=js&"
import style0 from "./reportList.vue?vue&type=style&index=0&id=66c01522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c01522",
  null
  
)

component.options.__file = "reportList.vue"
export default component.exports